import { render, staticRenderFns } from "./MailInboxChart.vue?vue&type=template&id=344cec2d&scoped=true"
import script from "./MailInboxChart.vue?vue&type=script&lang=js"
export * from "./MailInboxChart.vue?vue&type=script&lang=js"
import style0 from "./MailInboxChart.vue?vue&type=style&index=0&id=344cec2d&prod&lang=scss"
import style1 from "./MailInboxChart.vue?vue&type=style&index=1&id=344cec2d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344cec2d",
  null
  
)

export default component.exports